import analytics from '../index';

async function trackBackspaces(fieldId, fieldName) {
  const backspacePayload = {
    field_id:   fieldId,
    field_name: fieldName,
  };

  await analytics.track('backspace', backspacePayload);
}

function handleKeydownEvent(e) {
  const { target, key } = e;

  const { id, name } = target;

  if (key === 'Backspace' || key === 'Delete') {
    trackBackspaces(id, name);
  }
}

function addBackspaceEventListeners() {
  const inputs = document.getElementsByTagName('input');

  for (let i = 0; i < inputs.length; i += 1) {
    inputs[i].addEventListener('keydown', handleKeydownEvent);
  }
}

function removeBackspaceEventListeners() {
  const inputs = document.getElementsByTagName('input');

  for (let i = 0; i < inputs.length; i += 1) {
    inputs[i].removeEventListener('keydown', handleKeydownEvent);
  }
}

export {
  addBackspaceEventListeners,
  removeBackspaceEventListeners,
  handleKeydownEvent,
};
